const chromeStoreLink = 'https://chrome.google.com/webstore/detail/phishcloud/kiiikjhlelilgeljcacimkoaccpljjac';

export default chromeStoreLink;
